import React, { useState } from 'react';
import Modal from '../../../components/Modal/index';
import '../../../../sass/pages/account/bold_modal.scss';
import trackEvent from '../../../helpers/gtm/eventPush';

const BoldModal = () => {
  const [showDialog, updateShowDialog] = useState(false);

  const close = () => {
    updateShowDialog(false);
  };

  const open = () => {
    updateShowDialog(true);
  };

  const modalLabelText = <span>Bold Ads</span>;

  return (
    <>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText={modalLabelText}
          id="bold-modal"
          initialFocus=".modal__close"
        >
          <div className="bold-modal">
            <ul className="bold-modal__list">
              <li>
                <i className="far fa-check-circle"></i>Up to twice as many
                enquiries on average
              </li>
              <li>
                <i className="far fa-check-circle"></i>Rank higher in the search
                results
              </li>
              <li>
                <i className="far fa-check-circle"></i>Stand out more on the
                page
              </li>
              <li>
                <i className="far fa-check-circle"></i>Available after posting a
                free ad
              </li>
            </ul>
          </div>
        </Modal>
      ) : null}
      <button onClick={open} className="button button--link" type="button">
        What&apos;s this?
      </button>
    </>
  );
};

export default BoldModal;
